import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../components/SeoHead";
import MainBanner from "../../components/MainBanner";
import LatestNews from "../../components/LatestNews";
import AllSectors from "../../components/AllSectors";
import ImageWithTextWithOverlay from "../../components/ImageWithTextWithOverlay";
import SimpleFormWithBgImage from "../../components/SimpleFormWithBgImage";
import LatestTestimonials from "../../components/LatestTestimonials";

export default function JobSeekersPage({
  global,
  all_news,
  all_sectors,
  all_candidate_testimonials,
}) {
  return (
    <>
      <SeoHead
        page_name={`Job seekers | Project engineering and technical recruitment specialists | Carbon60`}
        canonical_link={`job-seekers`}
      />
      <MainBanner
        global={global}
        pathPrefix={`job_seekers_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Job Seekers</h1>
          </>
        }
        imageURL1={`/site-assets/images/job-seekers-main-banner.jpeg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        breadcrumb_title="Job Seekers"
      />
      <LatestTestimonials
        global={global}
        pathPrefix={`job_seekers_page.latest_testimonials`}
        customClass={`py-5`}
        content={
          <>
            <h2>Candidate's Testimonials</h2>
          </>
        }
        post={all_candidate_testimonials}
        swiperID={`latestTestimonialsSwiper`}
      />
      <AllSectors
        global={global}
        pathPrefix={`job_seekers_page.all_sectors`}
        customClass={`py-5`}
        content={""}
        post={all_sectors}
      />
      <LatestNews
        global={global}
        pathPrefix={`job_seekers_page.latest_news`}
        customClass={`py-5`}
        post={all_news}
        content={
          <>
            <h2>Latest News, Events & Insights</h2>
          </>
        }
        buttonLink={`/blog/`}
        buttonTitle={`View All Insights`}
      />
      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`job_seekers_page.multi_column_cta`}
        customClass={`py-5`}
        content={
          <>
            <h2>Want to be featured as an Employer?</h2>
            <p>
              We will feature your company as one to work for! Reach out to us
              today to learn more.
            </p>
          </>
        }
        buttonTitle={`Get in Touch`}
        buttonLink={`/contact-us`}
        imageURL={`/site-assets/images/ask-david.jpeg`}
        imageALT={`Job Seekers Featured Image`}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const news = (await Collection("news")).filter(function (post) {
    return (
      post.tag?.en.includes("Candidate") && post.country?.en == "United Kingdom"
    );
  });
  const sectors = (await Collection("sectors"))
    .filter((cat) => cat.solutions?.en === "Job Seekers")
    .filter(function (post) {
      return post.region?.en.includes("United Kingdom");
    });

  const candidate_testimonials = await Collection("candidate_testimonials");

  const all_candidate_testimonials = candidate_testimonials
    .orderBy("order")
    .getItems();
  const all_sectors = sectors.orderBy("order").getItems();
  const all_news = news.orderBy("order").getItems().slice(0, 8);
  return {
    props: {
      global,
      all_news,
      all_sectors,
      all_candidate_testimonials,
    },
  };
}
